import { useState } from 'react';

import { useSidebarSummaryContext } from '../../../../SidebarSummary.context';
import {
  AnimationItem,
  AnimationWrapper,
  ImageWrapper,
  StyledBasicTitle,
  StyledBiggerSubtitle,
  StyledImage,
  Wrapper,
} from './SurveyAnimation.styled';

interface SurveyAnimationProps {
  hideAnimation: boolean;
  onAnimationEnd?: () => void;
}

export const SurveyAnimation = ({
  hideAnimation,
  onAnimationEnd,
}: SurveyAnimationProps) => {
  const {
    state: { isOpen },
    config: { getTranslation },
  } = useSidebarSummaryContext();

  const [imageAnimationPhase, setImageAnimationPhase] = useState(0);

  const items = Array(11).fill(0);

  const handleAnimationEnd = () => {
    if (onAnimationEnd && hideAnimation) {
      onAnimationEnd();
    }
  };

  const handleImageAnimationEnd = () => {
    if (imageAnimationPhase === 0) {
      setImageAnimationPhase(1);
    }
  };

  return (
    <Wrapper $activeHideAnimation={hideAnimation} onAnimationEnd={handleAnimationEnd}>
      <ImageWrapper>
        <AnimationWrapper>
          {items.map((_, index) => (
            <AnimationItem
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              $index={index}
              $activeAnimation={isOpen}
            />
          ))}
        </AnimationWrapper>
        <StyledImage
          $activeAnimation={isOpen}
          $phase={imageAnimationPhase}
          onAnimationEnd={handleImageAnimationEnd}
          src="https://static.genially.com/genially/activities/surveyAnswerAggregated"
          alt="Survey Aggregated Image"
        />
      </ImageWrapper>
      <StyledBasicTitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.surveyAnswer.title')}
      </StyledBasicTitle>
      <StyledBiggerSubtitle $activeAnimation={isOpen}>
        {getTranslation(
          '__new.content.interactiveQuestion.sidebar.surveyAnswer.subtitle',
        )}
      </StyledBiggerSubtitle>
    </Wrapper>
  );
};
